<template>
    <div class="columnList">
        <div class="title" :style="{ 'border-top': isHome ? '1px solid #cfcdcd' : '' }">
            <div class="name">
                <slot name="name"></slot>
            </div>
            <div class="more" v-if="isHome">
                <router-link :to="{ path: type }">
                    <span>更多></span>
                </router-link>

            </div>
        </div>
        <div class="list">
            <div class="item" v-for="(item, index) in list">
                <a :href="item.article_url">
                    <div class="left">
                        <div class="title-play" v-if="isClassroom"></div>
                        <img :src="item.thumbnail_url" :alt="item.title" />
                    </div>
                    <div class="right">
                        <div class="tit">
                            {{ item.title }}
                        </div>
                        <div class="time">
                            {{ item.created_at_str }}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'columnList',
    props: {
        list: {
            type: Array,
            default: []
        },
        type: String,
        // 是否是首页 不是首页就没有更多和顶部边框线
        isHome: {
            type: Boolean,
            default: false
        },
        // 是否是课堂  课堂图片有播放
        isClassroom:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.columnList {
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;


        .name {
            font-size: 20px;
            font-weight: bold;
        }

        .more {
            a {
                text-decoration: none;
                color: #679f4f;
            }

            font-size: 12px;
            font-weight: 800;
            cursor: pointer;
        }
    }

    .list {
        .item {

            padding: 10px 0;

            a {
                color: #000;
                display: flex;
                text-decoration: none;

                .left {
                    position: relative;

                    .title-play {
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                        background-image: url(https://static.nbd.com.cn/images/column_video/icon_play.png);
                        background-size: 40px;
                        background-position: center;
                    }
                    img {
                    width: 160px;
                    height: 98px;
                    margin-right: 20px;
                    // flex-shrink: 0;
                }
                }

                

                .right {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .tit {
                        text-align: justify;
                        line-height: 22px;
                        font-size: 18px;
                        width: 100%;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    .time {
                        font-size: 14px;
                        color: #AEAEB2;
                    }
                }
            }
        }
    }
}
</style>